import { createPinia, setActivePinia } from 'pinia'
import { createStorePersistence } from './utils/storePersistence'
import { useMainStore, installMainStorePlugins } from './stores/main'

export const pinia = createPinia()
setActivePinia(pinia)

const mainStore = useMainStore(pinia)
export const persistStore = createStorePersistence({ storage: sessionStorage, key: 'vuex', store: mainStore })
installMainStorePlugins(pinia)

const store = {
  get state () {
    return mainStore.$state
  },
  get getters () {
    return new Proxy({}, {
      get (_, key) {
        return mainStore[key]
      }
    })
  },
  commit (type, payload) {
    if (typeof mainStore[type] !== 'function') {
      throw new Error(`Unknown store mutation: ${type}`)
    }
    return mainStore[type](payload)
  },
  subscribe (callback) {
    return mainStore.$subscribe((mutation, state) => {
      const mutationId = mutation.storeId || mutation.events?.key || mutation.type
      callback({ type: mutationId }, state)
    })
  }
}

export { useMainStore }
export default store
